import { VuetifyPreset } from "vuetify";
import i18n from "@/plugins/i18n";
import { iconfont } from "@/components/shared/icons/iconfont";

export const VuetifyConfig = {
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#534D69",
        secondary: "#9DDED5",
        accent: "#735B8B",
        error: "#C9006C",
        info: "#AAFFF3",
        success: "#00CAA8", //"rgba(150, 254, 150, 0.4)", //"#4CAF50",
        warning: "#FFC845",
        base: "#26232f",
      },
    },
  },
  lang: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    t: (key, ...params) => i18n.t(key, params),
  },
  icons: {
    iconfont: "mdi",
    values: iconfont,
  },
} as unknown as VuetifyPreset;
